// extracted by mini-css-extract-plugin
module.exports = {"root":"HowItWorks_root__p1tyK","list":"HowItWorks_list__bhTtV","item":"HowItWorks_item__xJNCJ"};